export default __webpack_public_path__ + "static/media/uk.1c45ff81.jpg";